import { AppText, AppIcon } from "@toothfairy/shared-ui";
import AppButton from "@toothfairy/shared-ui/AppButton";
import AppDropDown from "@toothfairy/shared-ui/AppDropDown";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";
import { View } from "react-native";
import { useTranslation } from "react-i18next";
import { isLargeScreen } from "../../MainViewContainer";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import Styles from "../../Styles/Styles";
import ToothFairyButton from "../../../Components/ToothFairyComponents/ToothFairyButton";
import ToothFairyPeriodFilter from "../../../Components/ToothFairyComponents/ToothFairyPeriodFilter";
import Constants from "../../../Constants";

const DashboardFilters = ({
  agents,
  selectedAgentId,
  onAgentChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onExport,
  isExportDisabled,
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();

  const agentOptions = [
    { id: "all", label: t("dashboard.chatAnalytics.allAgents") },
    ...(agents || []).map((agent) => ({
      id: agent.id,
      label: agent.label || agent.id,
    })),
  ];

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 15,
        marginBottom: 0,
        paddingVertical: 10,
        paddingHorizontal: 5,
        borderRadius: 12,
        zIndex: 10,
      }}
    >
      <View style={{ flexDirection: "row", alignItems: "center", zIndex: 3 }}>
        <AppText wrapperStyle={{ marginRight: 10 }}>
          {t("dashboard.chatAnalytics.agent")}
        </AppText>
        <AppDropDown
          dropDownStyle={{
            minWidth: 180,
            textAlign: "left",
            marginLeft: 0,
            borderColor: currentTheme?.theme?.border_color,
          }}
          isElevated={false}
          dropdownIconColor="transparent"
          items={agentOptions}
          propertyLabel="label"
          propertyValue="id"
          selectedValue={selectedAgentId}
          onValueChange={(value) => onAgentChange(value)}
        />
      </View>

      <View style={{ zIndex: 2 }}>
        <ToothFairyPeriodFilter
          startDate={startDate}
          endDate={endDate}
          onUpdateStartDate={onStartDateChange}
          onUpdateEndDate={onEndDateChange}
          paddingBottom={0}
        />
      </View>

      {onExport && (
        <View
          style={{
            marginLeft: isLargeScreen() ? "auto" : 0,
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <ToothFairyButton
            {...Styles.minifiedButtonStyle}
            style={{
              height: Constants.appButtonHeight,
              width: 120,
              marginLeft: 0,
              marginRight: 0,
            }}
            isClickable={!isExportDisabled}
            onPress={isExportDisabled ? undefined : onExport}
            title={t("dashboard.chatAnalytics.exportToCSV")}
          />
        </View>
      )}
    </View>
  );
};

export default DashboardFilters;
